// Upload Service
// Handles all file upload-related API calls

import authService from './Auth.services.js';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://the-live-cure-be.vercel.app/api';

class UploadService {
  // General image upload
  async uploadImage(imageFile) {
    try {
      const token = authService.getToken();
      
      if (!token) {
        throw new Error('No authentication token');
      }

      const formData = new FormData();
      formData.append('image', imageFile);

      const response = await fetch(`${API_BASE_URL}/upload/image`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Failed to upload image');
      }

      const data = await response.json();
      return data.imageUrl || data.url || data.result?.imageUrl || data.result?.url;
    } catch (error) {
      console.error('Upload image error:', error);
      throw error;
    }
  }

  // Document upload
  async uploadDocument(documentFile) {
    try {
      const token = authService.getToken();
      
      if (!token) {
        throw new Error('No authentication token');
      }

      const formData = new FormData();
      formData.append('document', documentFile);

      const response = await fetch(`${API_BASE_URL}/upload/document`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Failed to upload document');
      }

      const data = await response.json();
      return data.documentUrl || data.url || data.result?.documentUrl || data.result?.url;
    } catch (error) {
      console.error('Upload document error:', error);
      throw error;
    }
  }

  // Avatar upload
  async uploadAvatar(avatarFile) {
    try {
      const token = authService.getToken();
      
      if (!token) {
        throw new Error('No authentication token');
      }

      const formData = new FormData();
      formData.append('avatar', avatarFile);

      const response = await fetch(`${API_BASE_URL}/upload/avatar`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Failed to upload avatar');
      }

      const data = await response.json();
      return data.avatarUrl || data.url || data.result?.avatarUrl || data.result?.url;
    } catch (error) {
      console.error('Upload avatar error:', error);
      throw error;
    }
  }

  // Test upload (no auth required)
  async testUpload(file) {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await fetch(`${API_BASE_URL}/upload/test`, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Failed to test upload');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Test upload error:', error);
      throw error;
    }
  }
}

const uploadService = new UploadService();
export default uploadService;

